import React, { FC } from 'react';
import './index.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

const Services = React.forwardRef<HTMLDivElement, {}>(function Services(
  {},
  ref
) {
  return (
    <section id='services' key='services-section' ref={ref}>
      <div className='services-image-container'>
        <StaticImage
          src='../../images/one-fam-collage-desktop.jpg'
          alt='ONEFAM Counter'
          placeholder='none'
          style={{
            gridArea: '1/1',
          }}
          layout='fullWidth'
        />
      </div>
      <h1
        data-sal='slide-up'
        data-sal-duration='500'
        data-sal-easing='ease-in-out'
      >
        Services
      </h1>
      <div className='services-content'>
        <h2
          data-sal='slide-up'
          data-sal-duration='500'
          data-sal-easing='ease-in-out'
        >
          Services
        </h2>
        <div className='services-text'>
          <div
            className='text-container'
            data-sal='slide-up'
            data-sal-duration='500'
            data-sal-easing='ease-in-out'
          >
            <ul>
              <li>
                haircut + beard
                <br />
                grooming
              </li>
              <li>women's haircut</li>
              <li>senior's haircut</li>
              <li>
                children's haircut
                <br />
                (12 & under)
              </li>
            </ul>
            <ul>
              <li>hair color</li>
              <li>hair styling</li>
              <li>perm</li>
              <li>facial</li>
              <li>+ more</li>
            </ul>
          </div>
        </div>
      </div>
      <div className='services-mobile-image-container'>
        <StaticImage
          src='../../images/one-fam-collage-mobile.png'
          alt='ONEFAM Counter'
          placeholder='none'
          style={{
            gridArea: '1/1',
          }}
          layout='fullWidth'
        />
      </div>
    </section>
  );
});

export default Services;
